/**
 * @generated SignedSource<<be2f84a78a2d3002185f86d1190e8218>>
 * @relayHash 5df596d299e01fd8db8c244a3368d7e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 37d4104a90f6aa4caf309c6e726c19c722b1d87baa0aa5e21aa06669d2a1da97

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCapacityQuery } from './ui_jiraCapacityQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCapacityQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "37d4104a90f6aa4caf309c6e726c19c722b1d87baa0aa5e21aa06669d2a1da97",
    "metadata": {},
    "name": "ui_jiraCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
